var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLang)?_c('a',{staticClass:"vr-btn-mobile",attrs:{"href":_vm.vr,"target":"_blank"}},[_c('img',{attrs:{"src":require("../../../../assets/images/mobile/mobile_vr1.png")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }